export enum PERMISSIONS {
  ADMIN_PORTAL_USER = 'ADMIN_PORTAL_USER',
  BACK_OFFICE_USER_ADMIN = 'BACK_OFFICE_USER_ADMIN',
  BACK_OFFICE_USER_SUPERVISOR = 'BACK_OFFICE_USER_SUPERVISOR',
  BACK_OFFICE_USER_VIEW = 'BACK_OFFICE_USER_VIEW',
}
